export enum TableViewMode {
  flat = 'flat' /** Плоская таблица */,
  pivot = 'pivot' /** Сводная таблица */,
}

/** Режимы видимости колонок таблицы ( некоторые колонки отключаются для supervisor )*/
export enum TableVisibilityLevel {
  hr = 'hr',
  supervisor = 'supervisor',
}

export type TableBaseDataEntity = {
  lastUpdateDate: string;
  rootRecordEntityId: string;
};
